// extracted by mini-css-extract-plugin
module.exports = {"root":"RadioGroup_root__UvL0W","label":"RadioGroup_label__1k2WU","group":"RadioGroup_group__7ikZK"};